var _path, _rect, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5H24V21C24 22.6569 22.6569 24 21 24H10V5Z",
    fill: "black",
    fillOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 3,
    height: 10,
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 24C8.88071 24 10 22.8446 10 21.4194V14H5V21.4194C5 22.8446 6.11929 24 7.5 24Z",
    fill: "#CBCBCB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3862 7.38617L24.8148 13.622L23.1412 11.9484L18.5448 16.5448L16.0345 14.0344L20.6309 9.43808L18.5448 7.38617L25.3862 7.38617Z",
    fill: "#F47226"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 19,
    width: 10,
    height: 2,
    fill: "#113A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrep);
export default __webpack_public_path__ + "static/media/prep.32f5fa2d1f38349d209c02323bba8b4f.svg";
export { ForwardRef as ReactComponent };